module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Commode2-76dc24f56149900d362bed8fcd55c1a0.svg";